/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export type PhxMark = PhxMarkObj;

export type PhxMarkLabelAlignment = 'left' | 'right' | 'center';

export interface PhxMarkObj {
  label: string;
  labelAlignment?: PhxMarkLabelAlignment;
  active?: boolean;
  hideTick?: boolean;
}

export class PhxMarks {
  [key: string]: PhxMark;
}

/**
 * Processed steps that would be passed to sub components.
 */
export interface PhxExtendedMark {
  value: number;
  offset: number;
  config: PhxMark;
}

/**
 * Marks that would be rendered.
 */
export interface PhxDisplayedMark extends PhxExtendedMark {
  active: boolean;
  label: string;
  style?: PhxMarkStyle;
}

/**
 * Steps that would be rendered.
 */
export interface PhxDisplayedStep extends PhxExtendedMark {
  active: boolean;
  style?: object;
}

export type PhxSliderShowTooltip = 'always' | 'none' | 'hover';

export type PhxSliderValue = number[] | number;

export interface PhxSliderHandler {
  offset: number | null;
  value: number | null;
  active: boolean;
}

export type PhxFillType = 'full' | 'progress' | 'none';

export interface PhxSliderTrackStyle {
  bottom?: string | null;
  height?: string | null;
  left?: string | null;
  right?: string | null;
  width?: string | null;
  visibility?: string;
}

export type HorizontalPosition = Required<Pick<PhxSliderTrackStyle, 'left' | 'right'>>;

export interface PhxSliderStyle {
  left: number;
  top: number;
}

export interface PhxMarkStyle {
  transform: string;
  left: string;
}

export interface PhxHandleStyle extends HorizontalPosition {
  transform: string;
} 